import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TCFile } from '../../files/TCFile';

export type BreadcrumbItem = {
    id: string;
    display: string;
    folder?: TCFile;
};

export type BreadcrumbClickEvent = {
    currentCrumbs: Array<BreadcrumbItem>;
    clickedItem: BreadcrumbItem;
};

@Component({
    selector: 'custom-breadcrumb',
    templateUrl: './custom-breadcrumb.component.html'
})
export class CustomBreadcrumbComponent {
    @Input() breadcrumbItems: Array<BreadcrumbItem> = [];

    @Output() breadcrumbClick = new EventEmitter<BreadcrumbClickEvent>();

    onBreadcrumbClick(item: BreadcrumbItem, idx: number): void {
        this.breadcrumbItems = this.breadcrumbItems.slice(0, idx + 1);
        this.breadcrumbClick.emit({ currentCrumbs: this.breadcrumbItems, clickedItem: item });
    }
}
